// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__171Tl","left":"styles_left__1OzYu"};